import {createAction} from '@reduxjs/toolkit';

export const selectMosaic = createAction('mosaics/select');

export const setMosaicsMode = createAction('mosaics/setMode');
